import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy, Medal } from "lucide-react";

const fmtActive = (m) => (m >= 60 ? `${Math.floor(m / 60)}h ${m % 60}m` : `${m}m`);

export const AgentOfMonth = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/dashboard/agent-of-month").then(({ data: d }) => setData(d)).catch(() => setData(null));
  }, []);
  if (!data) { return null; }
  const w = data.winner;
  return (
    <div className="relative overflow-hidden border-2 border-red-600 bg-slate-950 text-white p-6 md:p-8" data-testid="agent-of-month-card">
      <Trophy className="absolute -right-6 -bottom-6 h-44 w-44 text-red-600/20" strokeWidth={1} />
      <div className="relative flex flex-col md:flex-row md:items-center gap-6">
        <div className="h-20 w-20 shrink-0 rounded-full bg-red-600 flex items-center justify-center shadow-lg shadow-red-600/40 aotm-glow">
          <Trophy className="h-10 w-10 text-white" strokeWidth={1.75} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-red-400">Agent of the Month &middot; {data.label}</div>
          {w ? (
            <>
              <div className="font-display text-3xl md:text-4xl font-black tracking-tight mt-1 truncate" data-testid="aotm-name">{w.name}</div>
              <div className="text-sm text-slate-300 mt-2" data-testid="aotm-stats">
                <b className="text-white">{w.solved}</b> tickets solved &middot; {w.handled} handled &middot; {fmtActive(w.active_minutes)} online
              </div>
            </>
          ) : (
            <div className="text-lg text-slate-300 mt-2" data-testid="aotm-empty">No tickets solved yet this month &mdash; the trophy is up for grabs.</div>
          )}
        </div>
        {data.runners_up?.length > 0 && (
          <div className="flex flex-col gap-2 md:min-w-[200px]" data-testid="aotm-runners-up">
            {data.runners_up.map((r, i) => (
              <div key={r.user_id} className="flex items-center gap-2 text-sm border border-white/10 bg-white/5 px-3 py-2">
                <Medal className={`h-4 w-4 ${i === 0 ? "text-slate-200" : "text-amber-600"}`} strokeWidth={1.75} />
                <span className="flex-1 truncate">{r.name}</span>
                <span className="font-mono text-xs text-slate-300">{r.solved}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
